import { get } from 'lodash-es';
import { BFFGet } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';

export type ToggleConfig = {
  enable: boolean;
  userList: string[];
  appIds: string[];
  fullRelease?: boolean;
};

export const getToggleConfig = async (configName: string): Promise<ToggleConfig | null> => {
  try {
    const res = await BFFGet(`/${API_PREFIX}/api/config/toggle`, {
      params: {
        configName,
      },
      // 拉配置不能太长，会阻塞页面，失败直接超时走默认逻辑
      timeout: 3000,
    });
    return {
      enable: get(res, 'data.enable', false),
      userList: get(res, 'data.userList', []),
      appIds: get(res, 'data.appIds', []),
      fullRelease: get(res, 'data.fullRelease', false),
    };
  } catch (e) {
    return null;
  }
};
